import { ext } from '@/utils/linkTarget'
import Link from 'next/link'
import Sup from '../sup'
import React from 'react'
import StarIcon from '../starIcon'
import ArrowButton from '@/components/molecules/arrowButton'

const editorRule = (size) => {
  return {
    block: {
      normal: ({ children }) =>
        children[0] === '' ? <br /> : <p>{children}</p>,
    },
    marks: {
      strong: ({ children }) => <strong>{children}</strong>,
      underline: ({ children }) => (
        <u className="underline underline-offset-4">{children}</u>
      ),
      sup: ({ children }) => <Sup size={size}>{children}</Sup>,
      em: ({ children }) => <em>{children}</em>,
      link: (props) => (
        <Link
          scroll={false}
          href={props.value?.href}
          {...ext(props.value?.href)}
          className="custom-underline group hover:text-khaki transition-all duration-500"
        >
          {props.children}
        </Link>
      ),
    },
    list: {
      bullet: ({ children }) => (
        <ul>
          {React.Children.map(children, (child, index) => (
            <li key={index} className="flex items-center gap-x-2">
              <StarIcon className="w-[7px] h-[7px]" />
              <span className="block">{child.props.children}</span>
            </li>
          ))}
        </ul>
      ),
    },
    types: {
      ctaButton: (props) => (
        <div className='button'>
          <ArrowButton
            name={props.value.name}
            link={props.value.link}
            target="_blank"
            className="my-smallMobile lg:my-smallDesktop mx-auto md:mx-0"
          />
        </div>
      ),
    },
  }
}

export default editorRule
